export default __webpack_public_path__ + "static/spacer_bottle_bg2-24dcf67f57afef425bd0a3a90b8ab567.jpg";